import React, { useEffect, useState } from "react";
import { Field, Form, Formik } from "formik";
import Modal, { ModalButton } from "../../Modal/Modal";
import Input from "../../Input/Input";
import { AddHfcpSchema } from "../../../utils/validation/validation";
import SelectInput from "../../Input/Select";
import { createUser } from "../../../redux/Actions/UsersActions";
import { connect } from "react-redux";
import { getFacility } from "../../../redux/Actions/FacilityActions";
import { assignCategoryOptions } from "../../../utils/functions/UpdateValues";
import TextArea from "../../../components/Input/TextArea";

const AddHfcp = (props) => {
  const {
    displayModal,
    closeModal,
    createUser,
    isCreating,
    getFacility,
    getFacilitiesSuccess,
    facilities,
    createSuccess,
    getUsers
  } = props;

  const [state, setState] = useState({
    facility: "",
  });
  const [facilityOptions, setFacilityOptions] = useState([]);
  const [gender, setGender] = useState("");

  useEffect(
    () => {
      if (createSuccess) {
        document.getElementById("addHfcp").reset();
        setState({
          facility: "",
        });
        getUsers(1, 10, "hfcp", false)
        closeModal("addHfcpModal");
      }
    },
    // eslint-disable-next-line
    [createSuccess]
  );

  useEffect(
    () => {
      getFacility();
    },
    // eslint-disable-next-line
    [getFacility]
  );

  useEffect(
    () => {
      if (getFacilitiesSuccess) {
        const updatedFacilities = assignCategoryOptions(facilities);
        setFacilityOptions(updatedFacilities);
      }
    },
    // eslint-disable-next-line
    [getFacilitiesSuccess]
  );

  const options = [
    { label: "Male", value: "male" },
    { label: "Female", value: "female" },
  ];

  const updateSelection = (data) => {
    setGender(data.value);
  };

  const updateSelection2 = (data) => {
    setState({
      ...state,
      facility: data.value,
    });
  };

  const initialValues = {
    first_name: "",
    last_name: "",
    username: "",
    gender: "",
    email: "",
    phone_number: "",
    full_address: "",
    facility: "",
    about: "",
    years_of_experience: "",
    specialization: "",
  };

  const submitValues = (values) => {
    const payload = {
      first_name: values.first_name,
      last_name: values.last_name,
      username: values.username,
      gender: gender,
      email: values.email,
      phone_number: values.phone_number,
      facility: state.facility,
      full_address: values.full_address,
      about: values.about,
      years_of_experience: values.years_of_experience,
      specialization: values.specialization,
    };

    createUser("hfcp", payload);
  };

  return (
    <Modal
      displayModal={displayModal}
      closeModal={closeModal}
      title={"Add New HFCP"}
      width={"568px"}
    >
      <Formik
        initialValues={initialValues}
        onSubmit={(values) => submitValues(values)}
        validationSchema={AddHfcpSchema}
      >
        {({ isValid, dirty, setFieldValue }) => {
          const disabled = gender === "" || isCreating || !(isValid && dirty);
          return (
            <Form id="addHfcp">
              <div className="form-grid3">
                <Field
                  name="first_name"
                  label="First Name"
                  placeholder="Enter first name"
                  component={Input}
                  emptyValue={setFieldValue}
                />
                <Field
                  name="last_name"
                  label="Last Name"
                  placeholder="Enter last name"
                  component={Input}
                  emptyValue={setFieldValue}
                />
              </div>
              <div className="form-grid2">
                <Field
                  name="username"
                  label="User Name"
                  placeholder="Enter user name"
                  component={Input}
                  emptyValue={setFieldValue}
                />
                <SelectInput
                  label={"Gender"}
                  options={options}
                  onChange={(data) => updateSelection(data)}
                  success={createSuccess}
                />
              </div>
              <div className="form-grid2">
                <Field
                  name="email"
                  label="Email"
                  placeholder="Enter email address"
                  component={Input}
                  emptyValue={setFieldValue}
                />
                <Field
                  name="phone_number"
                  label="Phone Number"
                  placeholder="Enter phone number"
                  component={Input}
                  emptyValue={setFieldValue}
                />
              </div>
              <div className="form-grid">
                <Field
                  name="about"
                  label="Description"
                  placeholder="Enter description"
                  component={TextArea}
                  emptyValue={setFieldValue}
                />
              </div>
              <div className="form-grid2">
                <SelectInput
                  label="Facility"
                  options={facilityOptions}
                  onChange={(data) => updateSelection2(data)}
                  success={createSuccess}
                />
                <Field
                  name="full_address"
                  label="Full Address"
                  placeholder="Enter full address"
                  component={Input}
                  emptyValue={setFieldValue}
                />
              </div>
              <div className="form-grid2">
                <Field
                  name="specialization"
                  label="Specialization"
                  placeholder="Enter specialization"
                  component={Input}
                  emptyValue={setFieldValue}
                />
                <Field
                  name="years_of_experience"
                  label="Years of Experience"
                  placeholder="Enter years of experience"
                  component={Input}
                  emptyValue={setFieldValue}
                />
              </div>

              <ModalButton
                text={"Create HFCP"}
                type={"submit"}
                testId={"button"}
                loadingText={"Creating..."}
                isLoading={isCreating}
                disabled={disabled}
              />
            </Form>
          );
        }}
      </Formik>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  isCreating: state.users.isCreating,
  getFacilitiesSuccess: state.facility.getSuccess,
  facilities: state.facility.facilities,
  createSuccess: state.users.createSuccess,
});

const mapDispatchToProps = (dispatch) => ({
  createUser: (type, payload) => dispatch(createUser(type, payload)),
  getFacility: () => dispatch(getFacility()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddHfcp);
